module.exports = "\n<app-register></app-register>\n"